import { ReactNode } from 'react';
import { useProfiles } from '../hooks/useProfiles';
import { ProfilesContext } from './useProfilesContext';

export const ProfilesProvider = ({ children }: { children: ReactNode }) => {
  const data = useProfiles();
  return <ProfilesContext.Provider value={data}>{children}</ProfilesContext.Provider>;
};
